module.exports = __webpack_public_path__ + "img/gps_logo.5a82c69d.png";